import { connect } from 'react-redux';
import UploadRapbu from '../../../../views/Finance/Budgeting/Budget/UploadRapbu.finance.view';

export default connect(null, null)(UploadRapbu);
